export default __webpack_public_path__ + "static/media/Ellipse.ad895071.svg";